import { twJoin } from 'tailwind-merge';
import { tv } from 'tailwind-variants';

export const useInputStyles = () => {
  return {
    inputStyle: tv({
      base: twJoin(
        'peer',
        'border-1 border rounded-3xl bg-white outline-none',
        'py-4 px-5',
        'transition-colors duration-300',
        'focus:border-primary',
        'disabled:text-gray-400',
        'placeholder-white hover:placeholder-gray-400',
      ),
      variants: {
        danger: {
          false: 'border-gray-30 focus:border-primary',
          true: 'text-red-500 border-red-500 focus:border-red-500',
        },
        password: {
          false: '',
          true: 'pr-14',
        },
      },
      defaultVariants: {
        error: false,
        password: false,
      },
    }),

    labelStyle: tv({
      base: twJoin(
        'absolute left-5 -top-0 -translate-y-1/2',
        'bg-white rounded-2xl select-none cursor-text',
        'px-1',
        'transition-all duration-300',
        'peer-focus:-top-0 peer-placeholder-shown:top-1/2',
        'flex items-center gap-0.5',
      ),
      variants: {
        danger: {
          false: 'text-gray-500 peer-focus:text-primary',
          true: 'text-red-500 peer-focus:text-red-500',
        },
        hoverAnimations: {
          false: '',
          true: 'peer-hover:-top-0 peer-placeholder-shown:top-1/2',
        },
      },
      compoundVariants: [
        {
          error: false,
          hoverAnimations: true,
          className: 'peer-hover:text-primary',
        },
        {
          error: true,
          hoverAnimations: true,
          className: 'peer-hover:text-red-500',
        },
      ],
      defaultVariants: {
        error: false,
        hoverAnimations: false,
      },
    }),
  };
};
